.container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 32px;
}
